import React, { useEffect, useState } from "react";

export default function RecoveryRing({ value = 0, size = 220, stroke = 14, label = "RECOVERY" }) {
  const [animated, setAnimated] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setAnimated(value), 80);
    return () => clearTimeout(t);
  }, [value]);

  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (animated / 100) * circumference;
  const color = value >= 67 ? "#C8F135" : value >= 34 ? "#F5A623" : "#FF3B30";

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E5E7EB" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(.2,.8,.2,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-display text-7xl leading-none" data-testid="recovery-ring-value">
          {Math.round(value)}
          <span className="text-3xl align-top ml-1">%</span>
        </div>
        <div className="eyebrow mt-2">{label}</div>
      </div>
    </div>
  );
}
